// extracted by mini-css-extract-plugin
export default {"block-spacer":"SrMOubh_rym4X5g3tLVI","blockSpacer":"SrMOubh_rym4X5g3tLVI","inline-spacer":"o3mQT0ZQ74FLg5V2pzCg","inlineSpacer":"o3mQT0ZQ74FLg5V2pzCg"};